module.exports = __webpack_public_path__ + "img/310.056c378a.jpg";